import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tianjia",
  "use": "icon-tianjia-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tianjia\"><path d=\"M808.96 609.28H215.04c-12.8 0-23.04-10.24-23.04-23.04s10.24-23.04 23.04-23.04h591.36c12.8 0 23.04 10.24 23.04 23.04 2.56 12.8-7.68 23.04-20.48 23.04z\" /><path d=\"M512 903.68c-12.8 0-23.04-10.24-23.04-23.04V289.28c0-12.8 10.24-23.04 23.04-23.04s23.04 10.24 23.04 23.04v591.36c0 12.8-10.24 23.04-23.04 23.04z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tianjia.svg
// module id = hzu9
// module chunks = 22